import React from "react";

const CartItem = ({ item, selected, onSelect, onDelete }) => {
    return (
        <div className={`cart-item ${selected ? "selected" : ""}`} onClick={() => onSelect(item.id)}>
            {/* ✅ 체크박스 클릭 시 부모 클릭 방지 */}
            <input
                type="checkbox"
                checked={selected}
                onChange={(e) => {
                    e.stopPropagation(); // 이벤트 전파 방지
                    onSelect(item.id);
                }}
                className="cart-checkbox"
            />
            <div className="cart-item-content">
                <img src={item.imageUrl} alt={item.title} className="item-image" />
                <div className="item-info">
                    <h3 className="item-title">{item.title}</h3>
                    <p className="item-description">{item.subscriptionPeriod}개월 * {item.quantity}개</p>
                    <p className="item-price">{item.discount} {item.price.toLocaleString()}원</p>
                </div>
            </div>
            {/* ✅ 삭제 버튼 클릭 시 모달 오픈 */}
            <button
                className="delete-btn"
                onClick={(e) => {
                    e.stopPropagation(); // 부모 클릭 이벤트 방지
                    onDelete(item.id);
                }}
            >
                ×
            </button>
        </div>
    );
};

export default CartItem;
